export default "__VITE_ASSET__ePmy9sov__"